import React from "react";
import svg90 from "../../../assets/svg/svg90.svg";
import svg91 from "../../../assets/svg/svg91.svg"; 
import svg41 from "../../../assets/svg/svg41.svg";
const items = [
  {
    title: "Mission",
    svg: svg90,
    desc: "smart, secure, and transparent financial tools that power growth and accountability.",
  },
  {
    title: "Vission",
    svg: svg91,
    desc: "To become Africa's most trusted and intelligent digital payment ecosystem  connecting people, institutions, and opportunities.",
  },
];
function MissionVision() {
  return (
    <>
    <div className="lg:py-[5rem] py-[2rem] lg:px-0 px-3 bg-[#F6F6F8] relative">
        <div className="flex lg:flex-row flex-col gap-[2rem]  justify-center">
      {items &&
        items?.map((item, index) => (
          <div key={index} className="rounded-[1.25rem] bg-white shadow-[0_2px_10px_0_rgba(0,0,0,0.07)] lg:max-w-[35rem] w-full p-[2.56rem] flex flex-col relative">
            <img className="w-[4rem] h-[4rem] object-contain" src={item?.svg} alt={item?.svg} />
            <div className="text-[#000] text-[1.5rem] font-[600] leading-[2rem]">
              {item?.title}
            </div>
            <div className="mt-[1rem] text-[#4F4770] text-[1rem] font-[400] leading-[1.625rem]">
              {item?.desc}
            </div>
            {index === 0 && (
              <img className="h-[2.48863rem] absolute -bottom-[3rem] left-0 hidden lg:block" src={svg41} alt="svg41"/>
            )}
          </div>
        ))}
        </div>
        {/* Show svg41 after cards on mobile only */}
        <img className="h-[2.48863rem] mt-[2rem] lg:hidden" src={svg41} alt="svg41"/>
    </div>

    </>
  );
}

export default MissionVision;
